import React from 'react'

const TextVerify = (props) => {
  React.useEffect(() => {
    return (
      () => {
      }
    )
  }, [])

  function handleOpenHint() {
    let hint = document.getElementById("hint")
    hint.innerText = "D: Down, L: Left, R: Right"
  }

  function handleVerify(e) {
    let input = document.getElementById("input")
    let alert = document.getElementById("alert")
    if (input.value.toLowerCase() === props.answer.toLowerCase()) {
      props.onVerify()
    } else {
      input.value = ""
      alert.innerText = "### Error ###"
    }
  }

  return (
    <div
      id="info"
      className="info"
      style={{
        position: "absolute",
        zIndex: 10,
        width: "100vw",
        height: "auto",
        bottom: "5vh",
        fontSize: "3vh",
        textAlign: "center"
      }}
    >
      <input
        id="input"
        maxLength={5}
        placeholder="*****"
        style={{
          outline: "none",
          border: "Grey solid 1px",
          borderRadius: "5px",
          color: "black",
          fontFamily: "monospace",
          fontSize: "16px",
          marginBottom: "2vh",
          background: "white",
          width: "30vw",
          height: "34px",
          textAlign: "center",
        }}
        onKeyDown={(e) => {if (e.keyCode === 13) handleVerify()}}
      />
      <div className="row p-2">
        <div
          id="hint"
          className="col-12"
          style={{backgroundColor: "rgba(200, 200, 200, 0.2)", color: "white", cursor: "pointer"}}
          onClick={handleOpenHint}
        >
          提示
        </div>
      </div>
      <div className="row p-2">
        <div
          className="col-12"
          style={{backgroundColor: "rgba(0, 255, 255, 0.5)", color: "white", cursor: "pointer"}}
          onClick={handleVerify}
        >
          確認
        </div>
      </div>
      <div
        id="alert"
        style={{
          color: "#ffce14",
          textAlign: "center",
          fontSize: "2vh"
        }}
      />
    </div>
  )
}

export default TextVerify
